import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Container, Button, Modal, Badge } from 'react-bootstrap';
import Header from '~/Components/Header/Header';
import CardNavigationTab from '~/Components/CardNavigationTab';
import { toast } from 'react-toastify';
import * as api from '~/Services/Service';
import Loading from '~/Components/Loading';
import { format } from '~/Utils/Helpers';
import history from '~/Config/history';
import TabDadosPessoais from './components/TabDadosPessoais';
import TabDadosBancarios from './components/TabDadosBancarios';
import TabGruposEmpresa from './components/TabGruposEmpresa';
import TabPermissoes from './components/TabPermissoes';
import AuthStorage from '~/Utils/AuthStorage';
import { caracteristicas } from '~/constant';
import { FaBan, FaCheck } from 'react-icons/fa';
import './usuarios.css';

var GRUPOS_CORRETOR = [195, 197, 214, 267];

var Usuarios = function() {
  var params = useParams();
  var id = params.id;
  var isNovoMode = !id || id === 'novo';
  var isGrupoTI = AuthStorage.isGrupoTI();
  var temPermissaoTotal = AuthStorage.temCaracteristica(caracteristicas.ManutencaoUsuario);
  const temGestorCorretor = AuthStorage.temCaracteristica(caracteristicas.VisualizaUsuarioCorretor);
  // W-0608: 661 amplia a visão (vê todos), mas não dá direito de escrita.
  const temSomenteConsulta = AuthStorage.temCaracteristica(caracteristicas.SomenteConsultaUsuarios);
  const somenteLeitura = temSomenteConsulta && !temPermissaoTotal && !temGestorCorretor;

  const apenasCorretor = !temPermissaoTotal && !temSomenteConsulta && temGestorCorretor;

  var _useState = function(val) {
    return useState(val);
  };

  var loadingState = _useState(true);
  var loading = loadingState[0];
  var setLoading = loadingState[1];
  var activeTabState = _useState('pessoais');
  var activeTab = activeTabState[0];
  var setActiveTab = activeTabState[1];
  var isCorretorState = _useState(false);
  var isCorretor = isCorretorState[0];
  var setIsCorretor = isCorretorState[1];
  var checkboxCorretorState = _useState(false);
  var checkboxCorretor = checkboxCorretorState[0];
  var setCheckboxCorretor = checkboxCorretorState[1];

  var defaultExpiracao = function() {
    var d = new Date();
    d.setFullYear(d.getFullYear() + 2);
    return d.toISOString().substring(0, 10);
  };

  var formDataState = _useState({
    dataCadastro: '',
    nomeUsuario: '',
    nome: '',
    apelido: '',
    codigoGrupo: '',
    nomeGrupo: '',
    status: '0',
    aprovador: 0,
    responsa: 'N',
    cargo: '',
    depto: '',
    departamento: '',
    celular: '',
    fone: '',
    email: '',
    cpf: '',
    sexo: '',
    dtNasc: '',
    dataHoraExpiracao: defaultExpiracao(),
    idCrm: '',
    foto: '',
    gerente: '',
    imobiliaria: '',
    possuiCertificado: false,
    validaDocumento: false,
    testemunhaContrato: false,
    aparecerRanking: false,
    smtpMail: '',
    usuarioMail: '',
    senhaMail: '',
    portaMail: '',
    tipoMail: '',
    codigoDocumentoDigitalAutenticacao: 1,
  });
  var formData = formDataState[0];
  var setFormData = formDataState[1];

  var cpfValidationErrorState = _useState('');
  var cpfValidationError = cpfValidationErrorState[0];
  var setCpfValidationError = cpfValidationErrorState[1];
  var loadingSalvarState = _useState(false);
  var loadingSalvar = loadingSalvarState[0];
  var setLoadingSalvar = loadingSalvarState[1];

  var creciListState = _useState([]);
  var creciList = creciListState[0];
  var setCreciList = creciListState[1];
  var fotoState = _useState(null);
  var foto = fotoState[0];
  var setFoto = fotoState[1];

  var showStatusModalState = _useState(false);
  var showStatusModal = showStatusModalState[0]; var setShowStatusModal = showStatusModalState[1];
  var loadingStatusState2 = _useState(false);
  var loadingStatusAction = loadingStatusState2[0]; var setLoadingStatusAction = loadingStatusState2[1];

  var showInativarCorretorModalState = _useState(false);
  var showInativarCorretorModal = showInativarCorretorModalState[0];
  var setShowInativarCorretorModal = showInativarCorretorModalState[1];
  var loadingInativarCorretorState = _useState(false);
  var loadingInativarCorretor = loadingInativarCorretorState[0];
  var setLoadingInativarCorretor = loadingInativarCorretorState[1];

  var podeInativarCorretor =
    AuthStorage.temCaracteristica(caracteristicas.ManutencaoUsuario) ||
    AuthStorage.temCaracteristica(caracteristicas.VisualizaUsuarioCorretor);

  var contaBancariaState = _useState({
    tipo: '',
    finalidade: '',
    tipo_cef: false,
    codigo_banco: '',
    agencia: '',
    digito_agencia: '',
    nome_agencia: '',
    nome_banco: '',
    numero_conta: '',
    digito_conta: '',
    tipo_conta: '',
    titular_conta: '',
    cpf: '',
    cod_lanc: '',
    tipo_chave_pix: '',
    chave_pix: '',
  });
  var contaBancaria = contaBancariaState[0];
  var setContaBancaria = contaBancariaState[1];

  // Lookups
  var gruposOptionsState = _useState([]);
  var gruposOptions = gruposOptionsState[0];
  var setGruposOptions = gruposOptionsState[1];
  var departamentosOptionsState = _useState([]);
  var departamentosOptions = departamentosOptionsState[0];
  var setDepartamentosOptions = departamentosOptionsState[1];
  var imobiliariasOptionsState = _useState([]);
  var imobiliariasOptions = imobiliariasOptionsState[0];
  var setImobiliariasOptions = imobiliariasOptionsState[1];
  var contasOptionsState = _useState([]);
  var contasOptions = contasOptionsState[0];
  var setContasOptions = contasOptionsState[1];

  var handleInputChange = function(field, value) {
    setFormData(function(prev) {
      var updated = Object.assign({}, prev);
      updated[field] = value;

      // Atualizar isCorretor quando grupo mudar
      if (field === 'codigoGrupo') {
        var grupoInt = parseInt(value) || 0;
        var ehCorretor = GRUPOS_CORRETOR.indexOf(grupoInt) >= 0;
        setIsCorretor(ehCorretor);
        if (ehCorretor) {
          setCheckboxCorretor(true);
        } else {
          setCheckboxCorretor(false);
          updated.gerente = '';
          updated.imobiliaria = '';
        }
      }

      if (field === 'cpf') {
        var needsCpf = updated.validaDocumento || updated.testemunhaContrato;
        var hasCpf = updated.cpf && updated.cpf.trim() !== '';
        setCpfValidationError(
          needsCpf && !hasCpf
            ? 'Para validar ou ser testemunha de documentos digitais, é necessário informar o CPF.'
            : ''
        );
      }
      return updated;
    });
  };

  var handleCheckboxChange = function(field) {
    setFormData(function(prev) {
      var updated = Object.assign({}, prev);
      updated[field] = !prev[field];
      var needsCpf = updated.validaDocumento || updated.testemunhaContrato;
      var hasCpf = updated.cpf && updated.cpf.trim() !== '';
      setCpfValidationError(
        needsCpf && !hasCpf
          ? 'Para validar ou ser testemunha de documentos digitais, é necessário informar o CPF.'
          : ''
      );
      return updated;
    });
  };

  var handleAparecerRankingChange = async function() {
    if (!id || isNovoMode) {
      toast.error('Salve o usuário antes de alterar a visibilidade no Ranking.');
      return;
    }
    var novoValor = !formData.aparecerRanking;
    setFormData(function(prev) {
      return Object.assign({}, prev, { aparecerRanking: novoValor });
    });
    try {
      if (novoValor) {
        await api.ativarRankingVendaUsuarioAdmin(id);
      } else {
        await api.inativarRankingVendaUsuarioAdmin(id);
      }
      toast.success(
        novoValor
          ? 'Usuário passará a aparecer no Ranking de Vendas.'
          : 'Usuário ocultado do Ranking de Vendas.'
      );
    } catch (e) {
      setFormData(function(prev) {
        return Object.assign({}, prev, { aparecerRanking: !novoValor });
      });
      var msg = e && e.message ? e.message : 'Erro ao atualizar visibilidade no Ranking de Vendas.';
      toast.error(msg);
    }
  };

  var handleCorretorCheckbox = function() {
    var novoValor = !checkboxCorretor;
    setCheckboxCorretor(novoValor);
    if (!novoValor) {
      setFormData(function(prev) {
        return Object.assign({}, prev, { gerente: '', imobiliaria: '' });
      });
      setContasOptions([]);
    }
  };

  var handleImobiliariaChange = function(value) {
    handleInputChange('imobiliaria', value);
    setContasOptions([]);
    if (value) {
      api
        .listarContasPorGrupoEmpresa(value)
        .then(function(res) {
          var lista = res || [];
          setContasOptions(
            lista.map(function(c) {
              return { value: c.codigo, label: c.apelido };
            })
          );
        })
        .catch(function() {});
    }
  };

  var carregarLookups = async function() {
    try {
      var results = await Promise.all([
        api.listarGruposUsuario(),
        api.listarDepartamentos(),
        api.listarImobiliarias(),
      ]);
      var grupos = results[0] || [];
      setGruposOptions(
        grupos.map(function(g) {
          return { value: g.codigo, label: g.codigo + ' - ' + g.nome };
        })
      );
      var deptos = results[1] || [];
      setDepartamentosOptions(
        deptos.map(function(d) {
          return { value: d.codigo, label: d.descricao };
        })
      );
      var imobs = results[2] || [];
      setImobiliariasOptions(
        imobs.map(function(i) {
          return { value: i.codigo, label: i.apelido };
        })
      );
    } catch (e) {
      /* ignore */
    }
  };

  var carregarDadosUsuario = async function(codigo) {
    setLoading(true);
    try {
      var response = await api.buscarUsuariosPorCodigo(codigo);
      var usuario = response.dados_usuario;
      var data = usuario.data_hora_criacao
        ? format.date(usuario.data_hora_criacao)
        : '';
      var codigoGrupo = usuario.codigo_grupo || 0;
      var ehCorretor = GRUPOS_CORRETOR.indexOf(codigoGrupo) >= 0;

      if (apenasCorretor && !ehCorretor) {
        toast.error('Você não tem permissão para visualizar este usuário.');
        history.push('/usuarios');
        return;
      }

      setIsCorretor(ehCorretor);

      // Se tem imobiliaria preenchida e é corretor, marcar checkbox
      if (
        ehCorretor &&
        (usuario.codigo_grupo_empresa_imobiliaria || usuario.gerente)
      ) {
        setCheckboxCorretor(true);
      }

      setFormData({
        status: usuario.status || '0',
        dataCadastro: data,
        nomeUsuario: usuario.nome_usuario || '',
        nome: usuario.nome || '',
        apelido: usuario.apelido || '',
        codigoGrupo: codigoGrupo || '',
        nomeGrupo: usuario.nome_grupo || '',
        aprovador: usuario.aprovador || 0,
        responsa: usuario.responsa || 'N',
        cargo: usuario.cargo || '',
        depto: usuario.depto || '',
        departamento: usuario.departamento || '',
        celular: usuario.cel || '',
        fone: usuario.fone || '',
        email: usuario.email || '',
        cpf: usuario.cpf || '',
        sexo: usuario.sexo || '',
        dtNasc: usuario.dt_nasc ? usuario.dt_nasc.substring(0, 10) : '',
        dataHoraExpiracao: usuario.data_hora_expiracao
          ? usuario.data_hora_expiracao.substring(0, 10)
          : '',
        idCrm: usuario.id_crm || '',
        foto: usuario.foto || '',
        gerente: usuario.gerente || '',
        imobiliaria: usuario.codigo_grupo_empresa_imobiliaria || '',
        possuiCertificado: usuario.possui_certificado_digital || false,
        validaDocumento: usuario.valida_documentos_digitais || false,
        testemunhaContrato: usuario.testemunha_contrato_digital_venda || false,
        aparecerRanking: usuario.ranking_venda || false,
        smtpMail: usuario.smtp_mail || '',
        usuarioMail: usuario.usuario_mail || '',
        senhaMail: usuario.senha_mail || '',
        portaMail: usuario.porta_mail || '',
        tipoMail: usuario.tipo_mail || '',
        codigoDocumentoDigitalAutenticacao:
          usuario.codigo_documento_digital_autenticacao || 1,
      });
      if (usuario.foto) setFoto(usuario.foto);

      // Carregar contas da imobiliária se corretor
      if (ehCorretor && usuario.codigo_grupo_empresa_imobiliaria) {
        try {
          var resContas = await api.listarContasPorGrupoEmpresa(
            usuario.codigo_grupo_empresa_imobiliaria
          );
          var lista = resContas || [];
          setContasOptions(
            lista.map(function(c) {
              return { value: c.codigo, label: c.apelido };
            })
          );
        } catch (e) {
          /* ignore */
        }
      }

      // Carregar conta bancária
      try {
        var resConta = await api.buscarContaBancaria(codigo);
        if (resConta && resConta.data) {
          var conta = resConta.data;
          setContaBancaria({
            tipo: conta.tipo || '',
            finalidade: conta.finalidade || '',
            tipo_cef: conta.tipo_cef === 'N' || false,
            codigo_banco: conta.codigo_banco || '',
            agencia: conta.agencia || '',
            digito_agencia: conta.digito_agencia || '',
            nome_agencia: conta.nome_agencia || '',
            nome_banco: conta.nome_banco || '',
            numero_conta: conta.numero_conta || '',
            digito_conta: conta.digito_conta || '',
            tipo_conta: conta.tipo_conta || '',
            titular_conta: conta.titular_conta || '',
            cpf: conta.cpf || '',
            cod_lanc: conta.cod_lanc || '',
            tipo_chave_pix: conta.tipo_chave_pix || '',
            chave_pix: conta.chave_pix || '',
          });
        }
      } catch (e) {
        /* conta pode não existir */
      }

      // Carregar CRECI
      try {
        var resCreci = await api.obterCreci(codigo);
        setCreciList(resCreci.dados_creci || []);
      } catch (e) {
        /* creci pode não existir */
      }
    } catch (e) {
      toast.error('Erro ao carregar dados do usuário');
    } finally {
      setLoading(false);
    }
  };

  useEffect(
    function() {
      // Bloquear cadastro de novo usuário se não for grupo TI
      if (isNovoMode && !isGrupoTI) {
        toast.error(
          'Somente usuários do grupo TI podem cadastrar novos usuários.'
        );
        history.push('/usuarios');
        return;
      }
      carregarLookups();
      if (!id || isNovoMode) {
        setLoading(false);
        return;
      }
      carregarDadosUsuario(id);
    },
    [id]
  );

  var handleGruposChanged = function(gruposEmpresa) {
    // Callback da tab GruposEmpresa — não altera mais isCorretor (agora é via Codigo_Grupo)
  };

  var montarPayloadAdmin = function() {
    return {
      nome_usuario: formData.nomeUsuario,
      nome_completo: formData.nome,
      apelido: formData.apelido && formData.apelido.trim()
        ? formData.apelido.trim()
        : null,
      codigo_grupo: parseInt(formData.codigoGrupo) || 0,
      aprovador: parseInt(formData.aprovador) || 0,
      status: formData.status || '0',
      responsa: formData.responsa || 'N',
      cargo: formData.cargo || '',
      depto: formData.depto || '',
      departamento: formData.departamento
        ? parseInt(formData.departamento)
        : null,
      email: formData.email || '',
      dt_nasc: formData.dtNasc || null,
      fone: format.clear(formData.fone || ''),
      cel: format.clear(formData.celular || ''),
      sexo: formData.sexo || '',
      data_hora_expiracao: formData.dataHoraExpiracao || null,
      gerente:
        checkboxCorretor && formData.gerente
          ? parseInt(formData.gerente)
          : null,
      imobiliaria:
        checkboxCorretor && formData.imobiliaria
          ? parseInt(formData.imobiliaria)
          : null,
      smtp_mail: formData.smtpMail || '',
      usuario_mail: formData.usuarioMail || '',
      senha_mail: formData.senhaMail || '',
      porta_mail: formData.portaMail ? parseInt(formData.portaMail) : null,
      tipo_mail: formData.tipoMail ? parseInt(formData.tipoMail) : null,
      codigo_documento_digital_autenticacao:
        parseInt(formData.codigoDocumentoDigitalAutenticacao) || 1,
    };
  };

  var corretorInativo = parseInt(formData.codigoGrupo) === 214;

  const handleConfirmarInativarCorretor = async function () {
    setLoadingInativarCorretor(true);
    try {
      if (corretorInativo) {
        await api.ativarCorretorAdmin(id);
        toast.success('Corretor ativado com sucesso!');
      } else {
        await api.inativarCorretorAdmin(id);
        toast.success('Corretor inativado com sucesso!');
      }
      setShowInativarCorretorModal(false);
      await carregarDadosUsuario(id);
    } catch (e) {
      var msg = (e && e.message) || 'Erro ao alterar status do corretor';
      toast.error(msg);
    } finally {
      setLoadingInativarCorretor(false);
    }
  };

  const handleConfirmarAlteracaoStatus = async function () {
    if (!temPermissaoTotal) {
      toast.error('Você não tem permissão para alterar o status deste usuário.');
      setShowStatusModal(false);
      return;
    }
    var estaAtivo = String(formData.status) !== '1';
    setLoadingStatusAction(true);
    try {
      if (estaAtivo) {
        await api.inativarUsuarioAdmin(id);
        toast.success('Usuário inativado com sucesso!');
      } else {
        await api.ativarUsuarioAdmin(id);
        toast.success('Usuário ativado com sucesso!');
      }
      setShowStatusModal(false);
      await carregarDadosUsuario(id);
    } catch (e) {
      var msg = (e && e.message) || 'Erro ao alterar status do usuário';
      toast.error(msg);
    } finally {
      setLoadingStatusAction(false);
    }
  };

  const handleSalvarNovoUsuario = async function() {
    if (!formData.nomeUsuario) {
      toast.error('Login é obrigatório');
      return;
    }
    if (!formData.nome) {
      toast.error('Nome é obrigatório');
      return;
    }
    if (!formData.codigoGrupo) {
      toast.error('Grupo é obrigatório');
      return;
    }
    setLoadingSalvar(true);
    try {
      var payload = montarPayloadAdmin();
      var res = await api.cadastrarUsuarioAdmin(payload);
      toast.success('Usuário criado com sucesso!');
      const rep = res && res.replicacao;
      if (rep) {
        const naoSync = [];
        if (rep.hml && rep.hml.status !== 'ok') naoSync.push('HML');
        if (rep.dev && rep.dev.status !== 'ok') naoSync.push('DEV');
        if (naoSync.length) {
          toast.warning(
            `Usuário criado, mas não sincronizado em: ${naoSync.join(', ')}`
          );
        }
      }
      if (res && res.codigo) {
        history.push('/usuarios/' + res.codigo);
      } else {
        history.push('/usuarios');
      }
    } catch (e) {
      var msg = e && e.message ? e.message : 'Erro ao criar usuário';
      toast.error(msg);
    } finally {
      setLoadingSalvar(false);
    }
  };

  const handleSalvar = async function() {
    if (!formData.nomeUsuario) {
      toast.error('Login é obrigatório');
      return;
    }
    if (!formData.nome) {
      toast.error('Nome é obrigatório');
      return;
    }
    if (!formData.codigoGrupo) {
      toast.error('Grupo é obrigatório');
      return;
    }
    setLoadingSalvar(true);
    try {
      var payload = montarPayloadAdmin();
      await api.atualizarUsuarioAdmin(id, payload);
      toast.success('Dados salvos com sucesso!');
    } catch (e) {
      var msg = e && e.message ? e.message : 'Erro ao salvar dados';
      toast.error(msg);
    } finally {
      setLoadingSalvar(false);
    }
  };

  if (loading) return <Loading />;

  var tabs = [
    {
      url: 'pessoais',
      label: 'Dados Pessoais',
      component: (
        <TabDadosPessoais
          formData={formData}
          handleInputChange={handleInputChange}
          handleCheckboxChange={handleCheckboxChange}
          onAparecerRankingChange={handleAparecerRankingChange}
          cpfValidationError={cpfValidationError}
          isNovoMode={isNovoMode}
          codigoUsuario={id}
          foto={foto}
          creciList={creciList}
          onSalvar={isNovoMode ? handleSalvarNovoUsuario : handleSalvar}
          loadingSalvar={loadingSalvar}
          gruposOptions={gruposOptions}
          departamentosOptions={departamentosOptions}
          imobiliariasOptions={imobiliariasOptions}
          contasOptions={contasOptions}
          isCorretor={isCorretor}
          checkboxCorretor={checkboxCorretor}
          onCorretorCheckbox={handleCorretorCheckbox}
          onImobiliariaChange={handleImobiliariaChange}
          isGrupoTI={isGrupoTI}
          somenteLeitura={somenteLeitura}
          temGestorCorretor={temGestorCorretor}
        />
      ),
    },
  ];

  if (checkboxCorretor && !isNovoMode) {
    tabs.push({
      url: 'bancarios',
      label: 'Dados Bancários',
      component: (
        <TabDadosBancarios
          codigoUsuario={id}
          contaBancaria={contaBancaria}
          setContaBancaria={setContaBancaria}
          somenteLeitura={somenteLeitura}
        />
      ),
    });
  }

  if (!apenasCorretor) {
    tabs.push({
      url: 'grupos',
      label: isNovoMode ? 'Grupos Empresa (salve primeiro)' : 'Grupos Empresa',
      isDisabled: isNovoMode,
      component: (
        <TabGruposEmpresa
          codigoUsuario={id}
          isNovoMode={isNovoMode}
          onGruposChanged={handleGruposChanged}
          somenteLeitura={somenteLeitura}
        />
      ),
    });

    tabs.push({
      url: 'permissoes',
      label: isNovoMode ? 'Permissões (salve primeiro)' : 'Permissões',
      isDisabled: isNovoMode,
      component: (
        <TabPermissoes
          codigoUsuario={id}
          isNovoMode={isNovoMode}
          codigoGrupo={formData.codigoGrupo}
          nomeGrupo={formData.nomeGrupo}
          somenteLeitura={somenteLeitura}
        />
      ),
    });
  }

  return (
    <>
      <Header
        title={isNovoMode ? 'Novo Usuário' : formData.nome || 'Alterar Dados'}
      >
        {!isNovoMode && checkboxCorretor && podeInativarCorretor && String(formData.status) !== '1' && (
          corretorInativo ? (
            <Button
              size="sm"
              variant="success"
              className="mr-2"
              onClick={function () { setShowInativarCorretorModal(true); }}
            >
              <FaCheck className="mr-1" /> Ativar Corretor
            </Button>
          ) : (
            <Button
              size="sm"
              variant="warning"
              className="mr-2"
              onClick={function () { setShowInativarCorretorModal(true); }}
            >
              <FaBan className="mr-1" /> Inativar Corretor
            </Button>
          )
        )}
        {temPermissaoTotal && (
          String(formData.status) !== '1' ? (
            <Button size="sm" variant="warning" className="mr-2" onClick={function () { setShowStatusModal(true); }}>
              <FaBan className="mr-1" /> Inativar
            </Button>
          ) : (
            <Button size="sm" variant="success" className="mr-2" onClick={function () { setShowStatusModal(true); }}>
              <FaCheck className="mr-1" /> Ativar
            </Button>
          )
        )}
        <Button size="sm" variant="outline-secondary" onClick={function () { history.push('/usuarios'); }}>
          Voltar
        </Button>
      </Header>
      <Container fluid className="mt-2 px-3">
        <CardNavigationTab
          activeTab={activeTab}
          onChangeTab={setActiveTab}
          tabs={tabs}
        />
      </Container>

      {!isNovoMode && showInativarCorretorModal && (
        <Modal show={true} onHide={function () { setShowInativarCorretorModal(false); }} centered>
          <Modal.Header closeButton>
            <Modal.Title>{corretorInativo ? 'Ativar' : 'Inativar'} Corretor</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Tem certeza que deseja {corretorInativo ? 'ativar' : 'inativar'} o corretor <strong>{formData.nome}</strong>?
            <br />
            <small className="text-muted">
              O usuário será movido para o grupo{' '}
              <strong>
                {corretorInativo
                  ? '195 - REVO-Corretores'
                  : '214 - REVO-Corretores Terceiros'}
              </strong>
              .
            </small>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={function () { setShowInativarCorretorModal(false); }}>
              Cancelar
            </Button>
            <Button
              variant={corretorInativo ? 'success' : 'warning'}
              onClick={handleConfirmarInativarCorretor}
              disabled={loadingInativarCorretor}
            >
              {loadingInativarCorretor
                ? 'Processando...'
                : (corretorInativo ? 'Ativar Corretor' : 'Inativar Corretor')}
            </Button>
          </Modal.Footer>
        </Modal>
      )}

      {!isNovoMode && showStatusModal && (function () {
        var estaAtivo = String(formData.status) !== '1';
        return (
          <Modal show={true} onHide={function () { setShowStatusModal(false); }} centered>
            <Modal.Header closeButton>
              <Modal.Title>{estaAtivo ? 'Inativar' : 'Ativar'} Usuário</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              Tem certeza que deseja {estaAtivo ? 'inativar' : 'ativar'} o usuário <strong>{formData.nome}</strong>?
              {estaAtivo && (
                <>
                  <br />
                  <small className="text-muted">Esta ação irá inativar o usuário e remover todos os seus vínculos.</small>
                </>
              )}
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={function () { setShowStatusModal(false); }}>Cancelar</Button>
              <Button
                variant={estaAtivo ? 'warning' : 'success'}
                onClick={handleConfirmarAlteracaoStatus}
                disabled={loadingStatusAction}
              >
                {loadingStatusAction ? 'Processando...' : (estaAtivo ? 'Inativar' : 'Ativar')}
              </Button>
            </Modal.Footer>
          </Modal>
        );
      }())}
    </>
  );
};

export default Usuarios;
